module.exports = __webpack_public_path__ + "static/media/app-bg.891644f6.svg";